import Lazyload from 'vanilla-lazyload';
import PubSub from 'pubsub-js';
import Hammer from 'hammerjs';
import Toggle from '../components/Toggle';
import { throttle } from 'lodash';
import $ from 'jquery';

require('../lib/scroll-fade');
require('magnific-popup');
require('slick-carousel');

const lightboxVideos = () => {
  const $btns = $('a.btn[href*="youtube.com"], a.btn[href*="vimeo.com"]');

  $btns.magnificPopup({
    type: 'iframe',
    removalDelay: 300,
    mainClass: 'vf-popup',
  });
};

const popupInit = function() {
  $('[data-popup]').magnificPopup({
    gallery: {
      enabled: true,
    },
    mainClass: 'popup-gallery',
  });
};

const gallery = function() {
  $('.gallery').magnificPopup({
    delegate: 'a',
    type: 'image',
    gallery: { enabled: true },
    mainClass: 'popup-gallery',
    removalDelay: 300,
  });
};

/**
 * Primary navigation - top level nav > sub-nav toggles.
 */
const navToggles = function() {
  let items = $('.nav-primary > .nav > .menu-item-has-children > a').get();

  items.forEach(function(item) {
    let hammer = new Hammer(item);

    hammer.on('tap', function(ev) {
      if (ev.pointerType == 'touch') {
        let $this = $(ev.target);
        let $closest = $this.closest('.menu-item--depth-1');

        if (! $closest.hasClass('open')) {
          ev.preventDefault();

          $closest.addClass('open');
        }

        PubSub.publish('nav-item:tap', {item: ev.target});
      }
    });
  });

  $('.nav-primary .caret').on('click', function() {
    $(this).closest('.menu-item--depth-1').toggleClass('open');
  });


  PubSub.subscribe('nav-item:tap', function(eventName, data) {
    $(data.item).parent().siblings().removeClass('open');
  });
};

const formFields = function () {
  let ancestor_selector = '.gfield, span';
  let ACTIVE_CLASS = 'active';
  let FILLED_CLASS = 'filled';

  $('.ginput_container')
    .find('input, textarea')
    .on('focus', function() {
      $(this).closest(ancestor_selector).addClass(ACTIVE_CLASS);
    })
    .on('blur', function() {
      $(this).closest(ancestor_selector).removeClass(ACTIVE_CLASS);
    })
    .on('change input', function() {
      let $this = $(this);
      let val = $this.val();

      if (val.length) {
        $this.closest(ancestor_selector).addClass(FILLED_CLASS);
      } else {
        $this.closest(ancestor_selector).removeClass(FILLED_CLASS);
      }
    });
};

const initLazyload = function() {
  let elements_selector = '[data-src], [data-original], [data-srcset], [data-original-set]';

  window.Lazyload = new Lazyload({
    elements_selector,
  });

  // Handle loading new lazy-loaded images when the events calendar
  // ajax functionality loads new events.
  if (window.tribe_ev) {
    $(window.tribe_ev.events).on('tribe_ev_ajaxSuccess', function() {
      window.Lazyload.update();
    });
  }
};

const initSliders = function() {
  $('.slick-slider').each(function() {
    let args = {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      arrows: true,
      swipeToSlide: true,
      autoplay: true,
      autoplaySpeed: 16000,
      pauseOnHover: true,
      dots: true,
    };

    $(this).slick(args);
  });
};

const toggles = () => {
  let toggles = document.querySelectorAll('.wrap .toggle');

  [].slice.call(toggles).forEach(function(toggle) {
    (new Toggle(toggle, { toggleSpeed: 250 })).initListeners();
  });

  // Header-specific nav-toggle functionality.
  let navToggle = new Toggle(document.querySelector('.banner .toggle'), { toggleSpeed: 250 });

  navToggle.clickHandler = function(e) {
    e.preventDefault();

    this.$target.slideToggle(this.opts.toggleSpeed);
    this.$toggle.toggleClass('active');

    document.body.classList.toggle('nav-open');
  };

  navToggle.reset = function() {
    this.$target.prop('style', false);

    this.$toggle.removeClass('active');

    document.body.classList.remove('nav-open');
  };

  navToggle.initListeners();
};

/**
 * Simple functionality to open/close the search form.
 */
const searchToggle = () => {
  const SEARCH_ACTIVE_CLASS = 'search-open';

  $('li.menu-search > a, a.search-toggle').on('click', e => {
    e.preventDefault();

    document.body.classList.toggle(SEARCH_ACTIVE_CLASS);

    let name = document.body.classList.contains(SEARCH_ACTIVE_CLASS) ? 'search:open' : 'search:close';

    PubSub.publish(name);
  });

  $('.search-close').click(() => {
    document.body.classList.remove(SEARCH_ACTIVE_CLASS);

    PubSub.publish('search:close');
  });

  $(document).on('keydown', e => {
    if (e.which == 27 && document.body.classList.contains(SEARCH_ACTIVE_CLASS)) {
      document.body.classList.remove(SEARCH_ACTIVE_CLASS);

      PubSub.publish('search:close');
    }
  });
};

/**
 * Add a class to the `body` tag when the user has scrolled
 * a certain amount - use this class to shrink the size of
 * the logo slightly to make it less distracting from
 * content down the page.
 */
const stickyHeaderSizing = () => {
  let $window = $(window);
  let ACTIVE_CLASS = 'sticky-header-in';
  let c = document.body.classList;
  let threshold = 50;

  function scrollHandler() {
    if ($window.scrollTop() > threshold) {
      c.add(ACTIVE_CLASS);
    } else {
      c.remove(ACTIVE_CLASS);
    }
  }

  $window.on('scroll', throttle(scrollHandler, 20));

  scrollHandler();
};

const downloadForm = () => {
  $('a[href="#form-download"]').magnificPopup({
    type: 'inline',
    mainClass: 'form-popup',
    removalDelay: 300,
  });

  $(document).on('gform_confirmation_loaded', function(){
    let $message= $('.gform_confirmation_message');
    let $link = $message.find('a');

    // Open the download in a new window after 3 seconds.
    if ($link.length > 0) {
      setTimeout(function() {
        window.open($link.attr('href'))
      }, 3000);
    }
  });
};

const smoothScroll = function() {
  // Click handler for any link element that starts with a hash.
  let $header = $('.banner-wrap');
  let left = 0;
  let behavior = 'smooth';

  $('a[href^="#"]').click(function(e) {
    e.preventDefault();

    let $target = $( this.hash );

    if ($target.length) {
      window.scroll({
        top: $target.offset().top - $header.outerHeight(),
        left,
        behavior,
      });
    }
  });

  window.addEventListener('load', function() {
    if (window.de_scrollpoint) {
      window.scroll({
        top: $(window.de_scrollpoint).offset().top - $header.outerHeight(),
        left,
        behavior,
      });
    }
  });
};


export default {
  init() {
    // JavaScript to be fired on all pages
    navToggles();
    formFields();
    initSliders();
    toggles();
    searchToggle();
    stickyHeaderSizing();
    lightboxVideos();
    popupInit();
    downloadForm();
    gallery();
    smoothScroll();
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    initLazyload();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js